const list = [
  {
    id: 1,
    name: 'HOME',
    path: '/',
  },
  {
    id: 2,
    name: 'MODELS',
    path: '/models',
  },
  {
    id: 3,
    name: 'APPOINTMENTS',
    path: '/appointments',
  },
  // {
  //   id: 4,
  //   name: 'images',
  //   path: '/images',
  // },
];

export default list;
